import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import {
  ImgContainer,
  LandingBlock,
  LandingContainer,
  ListContainer,
  ListItem,
  StyledButton,
  StyledLink,
} from "./HomePage.styled";
import { Link } from "react-router-dom";
import { loginRequest, b2cPolicies, features } from "../../authConfig";
import logo  from "../../shared/logo.jpg";

export const HomePage = () => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const { isProvider } = useSelector((state) => state.user);
  const handleLoginRedirect = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };
  const handleSignupRedirect = () => {
    if (!features.enableSelfRegistration) return;
    const authority = b2cPolicies.authorities.signup?.authority || b2cPolicies.authorities.signUpSignIn.authority;
    instance
      .loginRedirect({ authority, scopes: [...loginRequest.scopes] })
      .catch((error) => console.log(error));
  };
  
  return (
    <>
      <AuthenticatedTemplate>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LandingContainer>
          <LandingBlock>
            <ImgContainer>
              <img src={logo} alt="" />
            </ImgContainer>
          </LandingBlock>
          <LandingBlock>
            <Typography variant="h1">
              Welcome to the ILHIGA Assessment Portal
            </Typography>
            <ListContainer>
              <ListItem>
                <Typography variant="body2">
                  <StyledLink target="_blank" href="/faq/ILHIGA Vanguard Assessment Portal - Guide.pdf">
                    FAQs
                  </StyledLink>
                </Typography>
              </ListItem>
              <ListItem>
                <Typography variant="body2"> Phone: (773) 714-8050 </Typography>
              </ListItem>
              <ListItem>
                <Typography variant="body2">{"Email: "}</Typography>
                <StyledLink href="mailto:assessments@illinoisga.org">
                  assessments@illinoisga.org
                </StyledLink>
              </ListItem>
            </ListContainer>
            <StyledButton
              variant="contained"
              onClick={handleLoginRedirect}
            >
              Sign in to View NAIC member details
            </StyledButton>
            {features.enableSelfRegistration && (
              <StyledButton
                variant="text"
                sx={{ mt: 1, textDecoration: 'underline' }}
                onClick={handleSignupRedirect}
              >
                Create an account (dev)
              </StyledButton>
            )}
          </LandingBlock>
        </LandingContainer>
      </UnauthenticatedTemplate>
    </>
  );
};
